import { v4 as uuidv4 } from "uuid";
import Agent from "altus-agent";

import config from "infrastructure/config";
import authService from "services/auth.service";

const agent = new Agent(config, authService);

// Hijack requests that mutates data
// Generate a unique session-stored clientId that indicates which session did the request
// This is to prevent the websocket from triggering on their own changes
const _post = agent.post;
const _put = agent.put;
const _delete = agent.delete;

const wsClientId = uuidv4();
sessionStorage.setItem("wsClientId", wsClientId);

agent.post = (...args) => {
  if (args.length > 0) {
    args[0] = `${args[0]}?wsClientId=${wsClientId}`;
  }
  return _post(...args);
};

agent.put = (...args) => {
  if (args.length > 0) {
    args[0] = `${args[0]}?wsClientId=${wsClientId}`;
  }
  return _put(...args);
};

agent.delete = (...args) => {
  if (args.length > 0) {
    args[0] = `${args[0]}?wsClientId=${wsClientId}`;
  }
  return _delete(...args);
};

export default agent;
